import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsOfServiceDE() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Zurück zur App
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Nutzungsbedingungen</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE')}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Unternehmensinformationen</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Simple Stickers wird betrieben von <span className="font-semibold">Puretech s.r.o.</span>,
                  einer <span className="font-semibold">Gesellschaft mit beschränkter Haftung</span> nach dem Recht von <span className="font-semibold">Tschechien</span>.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm font-medium text-gray-700 mb-2">Unternehmensdetails:</p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li><strong>Identifikationsnummer (IČO):</strong> 05503795</li>
                    <li><strong>Umsatzsteuerstatus:</strong> Nicht steuerpflichtig</li>
                    <li><strong>Büroadresse:</strong> Heydukova 1035, 54401 Dvůr Králové nad Labem, Tschechien</li>
                    <li><strong>E-Mail:</strong> support@simplestickers.app</li>
                    <li><strong>Website:</strong> <a href="https://www.simplestickers.app" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 hover:underline">www.simplestickers.app</a></li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Annahme der Bedingungen</h2>
              <p className="leading-relaxed">
                Durch den Zugriff auf und die Nutzung von Simple Stickers ("der Dienst") akzeptieren Sie die Bedingungen dieser Vereinbarung und erklären sich damit einverstanden, an sie gebunden zu sein. Wenn Sie mit den oben genannten Bedingungen nicht einverstanden sind, nutzen Sie diesen Dienst bitte nicht.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Beschreibung des Dienstes</h2>
              <p className="leading-relaxed">
                Simple Stickers ist eine Aufgaben- und Projektverwaltungsanwendung, die Benutzern Werkzeuge zur Organisation von Haftnotizen mithilfe eines Kanban-Board-Systems bietet. Der Dienst umfasst sowohl kostenlose als auch Premium-Stufen mit unterschiedlichen Funktionen und Nutzungslimits.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Benutzerkonten</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Sie sind für die Wahrung der Vertraulichkeit Ihres Kontos und Passworts sowie für die Beschränkung des Zugriffs auf Ihren Computer verantwortlich. Sie erklären sich damit einverstanden, die Verantwortung für alle Aktivitäten zu übernehmen, die unter Ihrem Konto oder Passwort auftreten.
                </p>
                <p className="leading-relaxed">
                  Sie müssen bei der Erstellung Ihres Kontos genaue und vollständige Informationen angeben und diese Informationen auf dem neuesten Stand halten.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Abonnement und Zahlungsbedingungen</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Kostenlose Stufe:</strong> Beinhaltet Zugang zu Grundfunktionen mit Einschränkungen bei der Anzahl der Haftnotizen (50) und KI-Vorschlägen (10 pro Tag).
                </p>
                <p className="leading-relaxed">
                  <strong>Premium-Stufe:</strong> Erhältlich für 48 $ pro Jahr, beinhaltet erhöhte Limits (1000 Haftnotizen, 100 KI-Vorschläge pro Tag) und zusätzliche Funktionen wie die Möglichkeit, Haftnotizen zu teilen.
                </p>
                <p className="leading-relaxed">
                  Die Zahlungsabwicklung erfolgt über Polar. Abonnements verlängern sich automatisch, es sei denn, sie werden gekündigt. Sie können Ihr Abonnement jederzeit über Ihre Kontoeinstellungen kündigen.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Akzeptable Nutzung</h2>
              <p className="leading-relaxed">
                Sie erklären sich damit einverstanden, den Dienst nicht zum Speichern, Übertragen oder Verbreiten von Inhalten zu verwenden, die illegal, schädlich, bedrohlich, missbräuchlich, belästigend, verleumderisch, vulgär, obszön oder anderweitig anstößig sind. Sie erklären sich außerdem damit einverstanden, den Dienst nicht zu stören oder zu versuchen, auf Konten anderer Personen zuzugreifen.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Datenschutz und Schutz personenbezogener Daten</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Ihre Privatsphäre ist uns wichtig. Einzelheiten darüber, wie wir Ihre persönlichen Daten erheben, verwenden und schützen, finden Sie in unserer <a href="/privacy-policy" className="text-indigo-600 hover:text-indigo-800 hover:underline font-medium">Datenschutzerklärung</a>.
                </p>
                <p className="leading-relaxed">
                  Durch die Nutzung dieses Dienstes stimmen Sie auch unserer Datenschutzerklärung und der Verarbeitung Ihrer personenbezogenen Daten gemäß DSGVO und geltenden Datenschutzgesetzen zu.
                </p>
                <p className="leading-relaxed">
                  Um Ihre Rechte gemäß DSGVO auszuüben oder bei Fragen zum Datenschutz, kontaktieren Sie uns bitte unter <strong>support@simplestickers.app</strong>.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Dienstverfügbarkeit und Support</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Dienstverfügbarkeit:</strong> Wir streben maximale Dienstverfügbarkeit und zuverlässigen Betrieb an. Im Falle ungeplanter Ausfälle arbeiten wir daran, diese umgehend zu beheben. Der Dienst wird "wie besehen" ohne formelle Verfügbarkeitsgarantien bereitgestellt.
                </p>
                <p className="leading-relaxed">
                  <strong>Wartung:</strong> Um Sicherheit und Stabilität zu gewährleisten, können wir laufende Dienstwartungen durchführen. Wir versuchen, geplante Wartungsarbeiten während Zeiten geringer Nutzung zu planen und im Voraus zu informieren, wann immer möglich. In dringenden Fällen (z. B. Sicherheitspatches) kann die Wartung ohne vorherige Ankündigung erfolgen.
                </p>
                <p className="leading-relaxed">
                  <strong>Support:</strong> Wir bieten technischen Support per E-Mail unter support@simplestickers.app. Wir bemühen uns, so schnell wie möglich zu antworten, garantieren jedoch keine spezifischen Reaktionszeiten.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Rückerstattungsrichtlinie</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>30-Tage-Geld-zurück-Garantie:</strong> Wenn Sie mit dem Premium-Dienst nicht zufrieden sind, können Sie innerhalb von 30 Tagen nach Ihrem ersten Kauf eine vollständige Rückerstattung beantragen. Nach 30 Tagen sind alle Zahlungen endgültig und nicht erstattungsfähig.
                </p>
                <p className="leading-relaxed">
                  <strong>Abrechnungsfehler:</strong> Wenn Sie glauben, dass Ihnen fälschlicherweise Gebühren berechnet wurden, kontaktieren Sie uns unter support@simplestickers.app innerhalb von 30 Tagen nach der Belastung.
                </p>
                <p className="leading-relaxed">
                  <strong>Rückerstattungsabwicklung:</strong> Genehmigte Rückerstattungen werden innerhalb von 10-14 Werktagen auf die ursprüngliche Zahlungsmethode zurückerstattet. Wir behalten uns das Recht vor, Rückerstattungsanträge nach eigenem Ermessen zu genehmigen oder abzulehnen.
                </p>
                <p className="text-sm text-gray-600">
                  Hinweis: Abonnementkündigungen führen nicht automatisch zu Rückerstattungen. Sie müssen innerhalb der 30-Tage-Frist ausdrücklich eine Rückerstattung beantragen.
                </p>
              </div>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Altersbeschränkungen und Berechtigung</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Mindestalter:</strong> Sie müssen mindestens 16 Jahre alt sein, um diesen Dienst zu nutzen.
                </p>
                <p className="leading-relaxed">
                  <strong>Einwilligung der Eltern:</strong> Benutzer unter 18 Jahren benötigen die Zustimmung eines Elternteils oder Erziehungsberechtigten zur Nutzung des Dienstes.
                </p>
                <p className="leading-relaxed">
                  <strong>Geschäftsnutzer:</strong> Geschäftskonten erfordern, dass der Benutzer befugt ist, die Organisation zu binden.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Anwendbares Recht und Gerichtsstand</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Diese Bedingungen unterliegen den Gesetzen der Tschechischen Republik und werden nach diesen ausgelegt, ohne Rücksicht auf Kollisionsnormen.
                </p>
                <p className="leading-relaxed">
                  Alle Streitigkeiten, die sich aus diesen Bedingungen oder Ihrer Nutzung des Dienstes ergeben, unterliegen der ausschließlichen Gerichtsbarkeit der Gerichte der Tschechischen Republik.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Inhaltsmoderation</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Wir behalten uns das Recht vor, Inhalte zu entfernen, zu ändern oder deren Anzeige abzulehnen, die gegen diese Bedingungen verstoßen oder die wir nach eigenem Ermessen als unangemessen erachten.
                </p>
                <p className="leading-relaxed">
                  Wenn Sie der Meinung sind, dass Inhalte überprüft werden sollten, kontaktieren Sie uns unter support@simplestickers.app.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Geistiges Eigentum</h2>
              <p className="leading-relaxed">
                Der Dienst und sein ursprünglicher Inhalt, seine Merkmale und Funktionalität sind Eigentum von Simple Stickers und durch internationale Urheberrechts-, Marken-, Patent-, Geschäftsgeheimnis- und andere Gesetze zum Schutz des geistigen Eigentums geschützt.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Haftungsbeschränkung</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Im größtmöglichen gesetzlich zulässigen Umfang haftet Simple Stickers nicht für indirekte, zufällige, besondere, Folge- oder Strafschäden, einschließlich, aber nicht beschränkt auf Verlust von Gewinnen, Daten, Nutzung, Geschäftswert oder anderen immateriellen Verlusten, die sich aus Ihrer Nutzung des Dienstes ergeben.
                </p>
                <p className="leading-relaxed">
                  Diese Haftungsbeschränkung gilt nicht für Schäden, die durch vorsätzliches Fehlverhalten oder grobe Fahrlässigkeit verursacht wurden, oder soweit dies durch geltendes Recht verboten ist.
                </p>
                <p className="leading-relaxed">
                  Unsere Gesamthaftung Ihnen gegenüber für Ansprüche, die sich aus Ihrer Nutzung des Dienstes ergeben, übersteigt nicht den Betrag, den Sie uns in den 12 Monaten vor dem Anspruch gezahlt haben, oder 100 €, je nachdem, welcher Betrag höher ist.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Beendigung</h2>
              <p className="leading-relaxed">
                Wir können Ihr Konto kündigen oder aussetzen und den Zugang zum Dienst sofort, ohne vorherige Ankündigung oder Haftung, nach unserem alleinigen Ermessen, aus jedem Grund, einschließlich, aber nicht beschränkt auf einen Verstoß gegen die Bedingungen, sperren.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Änderungen der Bedingungen</h2>
              <p className="leading-relaxed">
                Wir behalten uns das Recht vor, diese Bedingungen jederzeit zu ändern oder zu ersetzen. Wenn eine Überarbeitung wesentlich ist, werden wir mindestens 30 Tage im Voraus informieren, bevor neue Bedingungen in Kraft treten.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Kontaktinformationen</h2>
              <div className="space-y-4">
                <p className="leading-relaxed">
                  Wenn Sie Fragen zu diesen Nutzungsbedingungen haben, kontaktieren Sie uns bitte:
                </p>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-700">
                    <strong>E-Mail:</strong> support@simplestickers.app
                  </p>
                  <p className="text-xs text-gray-500 mt-2">
                    Für alle Anfragen zu Support, rechtlichen Angelegenheiten, Datenschutz, Datenschutz und Geschäftsfragen
                  </p>
                </div>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
